import React from 'react';
import { withRouter } from 'react-router-dom';
import { SideMenu } from '../../components/layouts/SideMenu';
import { Header } from '../../components/layouts/Header';
import {
  AppContainer,
  MainContentContainer,
  BodyContainer,
} from '../../resources/styling/appStyle';
import AccountTabs from '../../components/account/AccountTabs';
import { PageTitle, sa } from '../../components/superAdminUi';
import { MatSubscriptionList } from './MatSubscriptionList';
import { SchoolSubscriptionList } from './SchoolSubscriptionList';

// Subscriptions overview for Super Admins, on the redesigned surface: group/school
// subscriptions and individual-school subscriptions live behind the shared pill tabs.
// Presentation only — each tab hosts the existing list component with its own data,
// filters and actions unchanged.

function SubscriptionList() {
  const subscriptionTabs = [
    {
      key: 'groups-schools',
      label: 'Groups & Schools',
      content: <MatSubscriptionList />,
    },
    {
      key: 'individual-schools',
      label: 'Individual Schools',
      content: <SchoolSubscriptionList />,
    },
  ];

  return (
    <AppContainer>
      <SideMenu />
      <BodyContainer>
        <Header />
        <MainContentContainer>
          <PageTitle style={{ marginBottom: sa.space.section }}>Subscriptions</PageTitle>
          <AccountTabs
            tabs={subscriptionTabs}
            defaultTabKey='groups-schools'
            idBase='subscriptions'
          />
        </MainContentContainer>
      </BodyContainer>
    </AppContainer>
  );
}

export default withRouter(SubscriptionList);
